import ConnectionType from "../common/connection-type";

export const supportsDispenseRetry = (connectionId) =>
  [
    ConnectionType.QS1,
    ConnectionType.MCKESSONERX,
    ConnectionType.EPIC,
    ConnectionType.EPIC_WITH_MTLS,
    ConnectionType.PIONEERRX,
    ConnectionType.LIBERTY_SOFTWARE,
    ConnectionType.DRX_INTEGRATION,
    ConnectionType.MSCRIPTS,
    ConnectionType.THIRD_PARTY,
    ConnectionType.PRIMERX,
    ConnectionType.SOLIS,
  ].includes(connectionId);

export const buildDispenseRetryRequest = (kind, selected) => {
  const orderId = selected && selected.order_id;
  if (!orderId) {
    return {
      error: "This pickup has no external order id, so dispense cannot be retried.",
    };
  }

  if (kind === "thirdParty") {
    return {
      path: "api/v1/subscriptions/completeRx/complete",
      method: "post",
      body: {
        order_ids: [orderId],
        account_id: selected.account_id,
        signature_url: selected.psignature_url,
      },
    };
  }

  if (kind === "primeRx") {
    return {
      path: "api/primerx/order/update",
      method: "post",
      body: {
        accountId: selected.account_id,
        order_id: orderId,
        patient_signature: selected.psignature_url,
      },
    };
  }

  if (kind === "solis") {
    return {
      path: "api/v2/integration/orders/status",
      method: "put",
      body: {
        account_id: selected.account_id,
        order_ids: [orderId],
        status: "PICKED_UP",
        signature: selected.psignature_url,
        use_costco_payload: true,
        vendor_identifier: "iLocalBox",
        timestamp: new Date().toISOString(),
      },
    };
  }

  return { error: "This connection type has no dispense retry." };
};

const authHeaders = () => ({
  Authorization:
    "Bearer " +
    JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
      .jwtToken,
  "Content-Type": "application/json",
});

export const requestDispenseRetry = async ({ path, method, body }) => {
  const response = await fetch(process.env.REACT_APP_BASEURL + path, {
    method,
    withCredentials: true,
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const text = await response.text();
  if (!text) {
    return `statusCode: ${response.status}`;
  }
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch (error) {
    return text;
  }
};



// WEBPACK FOOTER //
// ./src/components/reports/dispenseRetry.js